import { render, staticRenderFns } from "./SettingGoldBetweenHeroesAndSupports.vue?vue&type=template&id=55283a2e&scoped=true&"
import script from "./SettingGoldBetweenHeroesAndSupports.vue?vue&type=script&lang=js&"
export * from "./SettingGoldBetweenHeroesAndSupports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55283a2e",
  null
  
)

export default component.exports